module.exports = __webpack_public_path__ + "img/briefcase.2e1c1031.svg";